import { ItemConfig } from './types'

const CM_PX = 78.7
const STANDARD_WIDTH = 6000

export const TOTE_CONFIG_S: ItemConfig = {
  name: '12oz スタンダードキャンバストートバッグ(S)',
  vendor: 'トムス',
  vendor_code: '778-TCC_S',
  printable_sections: ['1', '2'],
  colors: [
    { name: 'ナチュラル', system_id: '106', hex: '#e6dfc8' },
    { name: 'ブラック', system_id: '005', hex: '#111011' },
  ],
  sizes: ['S'],
  sections: [
    {
      name: '表',
      id: '1',
      config: {
        width: 1576,
        height: 669,
      },
    },
    {
      name: '裏',
      id: '2',
      config: {
        width: 1576,
        height: 669,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: 2800,
      height: 2800,
      origin: { x: 2800 / 2, y: 800 },
      sizes: {},
      sections: [
        {
          id: '1',
          offset: {
            x: -(1576 / 2),
            y: 500,
          },
        },
      ],
    },
    {
      name: 'back',
      width: 2800,
      height: 2800,
      origin: { x: 2800 / 2, y: 800 },
      sizes: {},
      sections: [
        {
          id: '2',
          offset: {
            x: -(1576 / 2),
            y: 500,
          },
        },
      ],
    },
  ],
}

export const TOTE_CONFIG_M: ItemConfig = {
  name: '12oz スタンダードキャンバストートバッグ(M)',
  vendor: 'トムス',
  vendor_code: '778-TCC_M',
  printable_sections: ['1', '2'],
  colors: [
    { name: 'ナチュラル', system_id: '106', hex: '#e6dfc8' },
    { name: 'ブラック', system_id: '005', hex: '#111011' },
  ],
  sizes: ['M'],
  sections: [
    {
      name: '表',
      id: '1',
      config: {
        width: 1969,
        height: 1969,
      },
    },
    {
      name: '裏',
      id: '2',
      config: {
        width: 1969,
        height: 1969,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: 2500 },
      sizes: {},
      sections: [
        {
          id: '1',
          offset: {
            y: 5 * CM_PX,
            x: -(1969 / 2),
          },
        },
      ],
    },
    {
      name: 'back',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: 2500 },
      sizes: {},
      sections: [
        {
          id: '2',
          offset: {
            y: 5 * CM_PX,
            x: -(1969 / 2),
          },
        },
      ],
    },
  ],
}

export const TOTE_CONFIG_L: ItemConfig = {
  name: '12oz スタンダードキャンバストートバッグ(L)',
  vendor: 'トムス',
  vendor_code: '778-TCC_L',
  printable_sections: ['1', '2'],
  colors: [
    { name: 'ナチュラル', system_id: '106', hex: '#e6dfc8' },
    { name: 'ブラック', system_id: '005', hex: '#111011' },
  ],
  sizes: ['L'],
  sections: [
    {
      name: '表',
      id: '1',
      config: {
        width: 2362,
        height: 2362,
      },
    },
    {
      name: '裏',
      id: '2',
      config: {
        width: 2362,
        height: 2362,
      },
    },
  ],
  sides: [
    {
      name: 'front',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: 2500 },
      sizes: {},
      sections: [
        {
          id: '1',
          offset: {
            y: 5 * CM_PX,
            x: -(2362 / 2),
          },
        },
      ],
    },
    {
      name: 'back',
      width: STANDARD_WIDTH,
      height: STANDARD_WIDTH,
      origin: { x: STANDARD_WIDTH / 2, y: 2500 },
      sizes: {},
      sections: [
        {
          id: '2',
          offset: {
            y: 5 * CM_PX,
            x: -(2362 / 2),
          },
        },
      ],
    },
  ],
}
